import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ResolveProduceTagsQueryVariables = Types.Exact<{
  criteria: Array<Types.ProduceTagResolutionCriteriaInput> | Types.ProduceTagResolutionCriteriaInput;
}>;


export type ResolveProduceTagsQuery = { __typename?: 'Query', resolveProduceTags: Array<{ __typename?: 'ProduceTagResolutionResult', isResolved: boolean, matchedDimensions: Array<Types.ProduceTagDimension>, tagCode?: string | null, tagUpc?: string | null, tagSku?: string | null, materialItem?: { __typename?: 'MaterialItemDocument', tag?: { __typename?: 'MaterialItemTagData', source: Types.ProduceTagSource } | null } | null }> };

export type ProduceTagResolutionFragment = { __typename?: 'ProduceTagResolutionResult', isResolved: boolean, matchedDimensions: Array<Types.ProduceTagDimension>, tagCode?: string | null, tagUpc?: string | null, tagSku?: string | null, materialItem?: { __typename?: 'MaterialItemDocument', tag?: { __typename?: 'MaterialItemTagData', source: Types.ProduceTagSource } | null } | null };

export const ProduceTagResolutionFragmentDoc = new TypedDocumentString(`
    fragment ProduceTagResolution on ProduceTagResolutionResult {
  isResolved
  matchedDimensions
  tagCode
  tagUpc
  tagSku
  materialItem {
    tag {
      source
    }
  }
}
    `, {"fragmentName":"ProduceTagResolution"});
export const ResolveProduceTagsDocument = new TypedDocumentString(`
    query ResolveProduceTags($criteria: [ProduceTagResolutionCriteriaInput!]!) {
  resolveProduceTags(criteria: $criteria) {
    ...ProduceTagResolution
  }
}
    fragment ProduceTagResolution on ProduceTagResolutionResult {
  isResolved
  matchedDimensions
  tagCode
  tagUpc
  tagSku
  materialItem {
    tag {
      source
    }
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    ResolveProduceTags: build.query<ResolveProduceTagsQuery, ResolveProduceTagsQueryVariables>({
      query: (variables) => ({ document: ResolveProduceTagsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useResolveProduceTagsQuery, useLazyResolveProduceTagsQuery } = injectedRtkApi;
